<template>
    <v-container class="fill-height data-container" style="padding: 0px;" fluid>

        <span class="title" style="margin-top: -5px; margin-bottom: 3px;">Permissions</span>

        <div id="ag-grid-permissions-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                :groupHeaders="true"
                :rowHeight="40">
            </ag-grid-vue>
        </div>

        <v-btn class="mt-3 mr-3" color="#c42111" @click="newPermissionClick" :disabled="$props.disabled || ($props.type == 'group' && !isCustomerAdmin)">New</v-btn>
        <v-btn class="mt-3 mr-3" color="#c42111" @click="showAllPermissions = true" v-if="$props.type == 'user'">All Permissions</v-btn>
        <span style="color: #FB8C00;" v-if="showIssueWarning">WARNING: allowing 'issue/close' without also allowing 'issue/revise'.</span>

        <v-dialog v-model="showEditPermission" max-width="80%" width="550px" persistent @keydown="(k) => {k.key == 'Escape' ? showEditPermission = false : null}">
            <permission-edit v-if="showEditPermission" :permission="selectedPermissionClone" :permissionsList="permissionsList" @cancel="cancelPermissionEdit" @ok="applyPermissionEdit"></permission-edit>
        </v-dialog>

        <v-dialog v-model="showAllPermissions" max-width="80%" width="1200px" persistent v-if="showAllPermissions" @keydown="(k) => {k.key == 'Escape' ? showAllPermissions = false : null}">
            <all-permissions :userPermissions="$props.activePermissions" :userId="$props.id"  @close="showAllPermissions = false" v-if="showAllPermissions"></all-permissions>
        </v-dialog>

    </v-container>
</template>

<script>
import PermissionEdit from "@/components/Users/PermissionEdit";
import AllPermissions from "@/components/Users/AllPermissions";
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'Permissions',
    props: ['type', 'id', 'permissionsList', 'activePermissions', 'lockSave', 'disabled'],
    components: {
        'ag-grid-vue': AgGridVue,
        PermissionEdit,
        AllPermissions
    },
    data: () => ({
        showGrid: false,
        gridOptions: null,
        showEditPermission: false,
        selectedPermissionIdx: null,
        selectedPermissionClone: null,
        showAllPermissions: false
    }),

    computed: {
        showIssueWarning: function() {
            let closeAllowed = this.$props.activePermissions.some(p => {
                return (p.perm_function == 'issue/close' && p.perm_action == 'ALLOW');
            });
            if(closeAllowed) {
                return !this.$props.activePermissions.some(p=> {
                    return (
                        (p.perm_function == 'issue/revise' && p.perm_action == 'ALLOW') ||
                        (p.perm_function == 'issue/*' && p.perm_action == 'ALLOW') ||
                        (p.perm_function == '*' && p.perm_action == 'ALLOW')
                    );
                })
            }
            return false;
        },

        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        }
    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.activePermissions;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: ${self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-tres-action" style="cursor: ${self.$props.lockSave || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${self.$props.lockSave || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.$props.disabled && !(self.$props.type == 'group' && !self.isCustomerAdmin)) {
                                this.editPermissionClick(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.$props.lockSave && !self.$props.disabled && !(self.$props.type == 'group' && !self.isCustomerAdmin)) {
                                this.deletePermission(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Rank #', 
                    field: 'perm_rank', 
                    width: 70, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Action', 
                    field: 'perm_action', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Function', 
                    field: 'perm_function', 
                    width: 200, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Resource', 
                    field: 'perm_qualifier', 
                    width: 250, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.isTop = params.data.perm_rank == 1;
                            this.isBottom = params.data.perm_rank == self.$props.activePermissions.length;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-arrow-up-circle perm-action" style="cursor: ${this.isTop || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${this.isTop || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-arrow-down-circle perm-action" style="cursor: ${this.isBottom || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? 'default' : 'pointer'}; color: ${this.isBottom || self.$props.disabled || (self.$props.type == 'group' && !self.isCustomerAdmin) ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.moveUpButtonHandler = this.moveUpButtonHandler.bind(this);
                            this.moveDownButtonHandler = this.moveDownButtonHandler.bind(this);

                            this.moveUpButton = this.eGui.querySelectorAll('.perm-action')[0];
                            this.moveDownButton = this.eGui.querySelectorAll('.perm-action')[1];
                            this.moveUpButton.addEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.addEventListener('click', this.moveDownButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        moveUpButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveUpFunction(this.params, this.isTop);
                        }
                        moveDownButtonHandler(event) {
                            event.stopPropagation();
                            this.params.moveDownFunction(this.params, this.isBottom);
                        }
                        destroy() {
                            this.moveUpButton.removeEventListener('click', this.moveUpButtonHandler);
                            this.moveDownButton.removeEventListener('click', this.moveDownButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        moveUpFunction: (params, isTop) => {
                            if(!isTop && !self.$props.disabled && !(self.$props.type == 'group' && !self.isCustomerAdmin)) {
                                this.moveUp(params.data);
                            }
                        },
                        moveDownFunction: (params, isBottom) => {
                            if(!isBottom && !self.$props.disabled && !(self.$props.type == 'group' && !self.isCustomerAdmin)) {
                                this.moveDown(params.data);
                            }
                        }
                    }
                },
            ];
            return columnDefs;
        },

        newPermissionClick: function() {
            let newPermission = {
                group_id: this.$props.type == 'group' ? this.$props.id : 0,
                perm_action: "ALLOW",
                perm_function: "",
                perm_qualifier: "",
                perm_rank: this.$props.activePermissions.length + 1,
                user_id: this.$props.type == 'user' ? this.$props.id : 0,
            };
            this.selectedPermissionIdx = -1;
            this.selectedPermissionClone = newPermission;
            this.showEditPermission = true;
        },

        editPermissionClick: function(permission) {
            this.selectedPermissionIdx = this.$props.activePermissions.indexOf(permission);
            this.selectedPermissionClone = JSON.parse(JSON.stringify(permission));
            this.showEditPermission = true;
        },

        cancelPermissionEdit: function() {
            this.showEditPermission = false;
            this.selectedPermissionIdx = null;
            this.selectedPermissionClone = null;
        },

        applyPermissionEdit: function() {
            if(this.selectedPermissionIdx > -1) {
                this.$props.activePermissions[this.selectedPermissionIdx] = this.selectedPermissionClone;
            }
            else {
                this.$props.activePermissions.push(this.selectedPermissionClone);
            }

            this.showEditPermission = false;
            this.gridOptions.api.setRowData(this.$props.activePermissions);
            this.selectedPermissionIdx = null;
            this.selectedPermissionClone = null;
        },

        deletePermission: function(permission) {
            for(const [idx, p] of this.$props.activePermissions.entries()) {
                if(p.perm_rank == permission.perm_rank) {
                    this.$props.activePermissions.splice(idx, 1);
                    break;
                }
            }
            for(const [idx, p] of this.$props.activePermissions.entries()) {
                p.perm_rank = (idx + 1);
            }
            this.gridOptions.api.setRowData(this.$props.activePermissions);
        },

        moveUp: function(permission) {
            this.swapPermissions(this.$props.activePermissions.indexOf(permission), (this.$props.activePermissions.indexOf(permission) - 1));
        },

        moveDown: function(permission) {
            this.swapPermissions(this.$props.activePermissions.indexOf(permission), (this.$props.activePermissions.indexOf(permission) + 1));
        },

        swapPermissions: function(idx1, idx2) {
            let temp = this.$props.activePermissions[idx1];
            this.$props.activePermissions[idx1] = this.$props.activePermissions[idx2];
            this.$props.activePermissions[idx2] = temp;
            for(const [idx, p] of this.$props.activePermissions.entries()) {
            p.perm_rank = (idx + 1);
            }
            this.gridOptions.api.setRowData(this.$props.activePermissions);
        }
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    #ag-grid-permissions-container {
        height: calc(100vh - 290px);
        width: 100%;
    }

</style>
